<template>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <Loading v-if="showLoading" />
            <div class="card mb-3 pt-3">
                <form class="row m-0" v-on:submit.prevent="submit">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>نام</label>
                            <input type="text" class="form-control" v-model="name">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>نام خانوادگی</label>
                            <input type="text" class="form-control" v-model="lastName">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>کد ملی</label>
                            <input type="tel" class="form-control ltr-input" v-model="nationalNo" maxlength="10">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>شماره همراه</label>
                            <input type="tel" class="form-control ltr-input" v-model="phone" maxlength="11">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>ایمیل</label>
                            <input type="email" class="form-control ltr-input" v-model="email">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>تاریخ تولد</label>
                            <Datepicker simple auto-submit locale="fa" v-model="birthDate" :max="maxDate" :locale-config="{
                                fa: {
                                    displayFormat: 'jYYYY/jMM/jDD',
                                    lang: {label: 'شمسی'}
                                }
                            }" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>رمز عبور</label>
                            <input type="password" class="form-control ltr-input" v-model="password">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>تکرار رمز عبور</label>
                            <input type="password" class="form-control ltr-input" v-model="confirmPassword">
                        </div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <button class="btn btn-success">ایجاد کاربر</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment-jalaali';
export default {
    name: 'Update',
    data(){
        return {
            showLoading: false,
            name: '',
            lastName: '',
            phone: '',
            password: '',
            confirmPassword: '',
            nationalNo: '',
            birthDate: '',
            email: '',
            maxDate: moment().format('jYYYY/jM/jD')
        }
    },
    methods: {
        getData(){

        },
        submit(){
            if(this.password != this.confirmPassword){
                this.$swal({
                    title: 'خطا',
                    icon: 'error',
                    text: 'رمز عبور و تکرار رمز عبور یکسان نیستند',
                    confirmButtonText: 'متوجه شدم'
                });
                return false;
            }
            this.showLoading = true;
            const postedData = {
                name: this.name,
                lastName: this.lastName,
                phone: this.phone,
                password: this.password,
                confirmPassword: this.confirmPassword,
                nationalNo: this.nationalNo,
                birthDate: this.birthDate,
                email: this.email
            };
            this.$api.post('Management/RegisterLegalCustomer',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'سازمان با موفقیت ایجاد شد'
                    }).then(() => {
                        this.$router.push({name: 'users'});
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>